import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationBg from "./locales/bg/translation.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: "en",
    fallbackLng: "en",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      bg: {
        translations: translationBg,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

i18n.on('languageChanged', (lng) => (document.documentElement.lang = lng))

export default i18n;